<template>
  <div>
    <Spin fix v-show="value">
      <input :value="value" @input="updateVal($event.target.value)" type="hidden" />
      <div class="spinner" :style="{ backgroundColor: 'rgba(255, 255, 255, '+transparency+')'}">
        <div :style="{backgroundColor: color}" class="rect1"></div>
        <div :style="{backgroundColor: color}" class="rect2"></div>
        <div :style="{backgroundColor: color}" class="rect3"></div>
        <div :style="{backgroundColor: color}" class="rect4"></div>
        <div :style="{backgroundColor: color}" class="rect5"></div>
      </div>
      <div :style="{color: color}" class="spinner-text">{{spinnerText}}</div>
    </Spin>
  </div>
</template>
<script>
export default {
	name: "spinner",
  props: {
    spinnerText: {
			Type: String,
			default: "拼命加载中。。。"
    },
    value: {
      Type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#515a6e"
    },
    transparency: {
      type: Number,
      default: 0
    }
  },
  methods: {
    updateVal: function(val) {
      this.$emit("input", val);
    }
  }
};
</script>
<style lang="less" scoped>
.spinner {
  margin: 0 auto;
  width: 50px;
  height: 56px;
  text-align: center;
  font-size: 10px;
}
.spinner-text {
  color: #515a6e;
  font-size: 13px;
  font-weight: 600;
}
.ivu-spin-fix {
  background-color: rgba(255, 255, 255, 0.0);
  z-index: 9999;
}

.spinner > div {
  background-color: #515a6e;
  border-radius: 4px;
  height: 100%;
  width: 4px;
  display: inline-block;
  -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
  animation: stretchdelay 1.2s infinite ease-in-out;
}
.spinner > div + div {
  margin-left: 3px;
}
.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.3);
  }
  20% {
    -webkit-transform: scaleY(0.65);
  }
}

@keyframes stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.3);
    -webkit-transform: scaleY(0.3);
  }
  20% {
    transform: scaleY(0.65);
    -webkit-transform: scaleY(0.65);
  }
}
</style>